document.addEventListener('DOMContentLoaded', () => {
    const sidebar = document.querySelector('.member-countries'); // Sidebar principal
    const footer = document.querySelector('footer'); // Selecione o footer
    const headerOffset = 110; // Posição fixa da sidebar ao rolar
    const initialTop = 235; // Posição inicial
    const footerOffset = 20; // Espaço entre a sidebar e o footer

    let sidebarHeight = sidebar.offsetHeight; // Altura da sidebar
    let lastScrollTop = 0; // Última posição do scroll

    // Recalcula altura e posições ao redimensionar a janela
    const recalculateDimensions = () => {
        sidebarHeight = sidebar.offsetHeight;
    };

    // Verifica se a largura da tela está acima do limite para aplicar o comportamento da sidebar fixa
    const isDesktop = () => window.innerWidth > 768;

    // Atualiza a posição da sidebar com base no scroll
    const updateSidebarPosition = () => {
        if (!isDesktop()) {
            // Desabilita comportamento da sidebar no mobile
            sidebar.style.position = '';
            sidebar.style.top = '';
            return;
        }

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        const footerTop = footer.getBoundingClientRect().top + scrollTop; // Topo do footer no documento
        const stopPoint = footerTop - sidebarHeight - footerOffset; // Posição onde a sidebar deve parar

        if (scrollTop + headerOffset + sidebarHeight >= stopPoint) {
            // Quando atingir o footer, fixa acima dele
            sidebar.style.position = 'absolute';
            sidebar.style.top = `${stopPoint}px`;
        } else if (scrollTop > lastScrollTop && scrollTop > initialTop) {
            // Scroll para baixo: fixa na posição de rolagem
            sidebar.style.position = 'fixed';
            sidebar.style.top = `${headerOffset}px`;
        } else if (scrollTop < lastScrollTop && scrollTop > initialTop) {
            // Scroll para cima: fixa na posição de rolagem
            sidebar.style.position = 'fixed';
            sidebar.style.top = `${headerOffset}px`;
        } else if (scrollTop <= initialTop) {
            // Retorna à posição inicial
            sidebar.style.position = 'fixed';
            sidebar.style.top = `${initialTop}px`;
        }

        // Atualiza o último valor de scroll
        lastScrollTop = scrollTop;
    };

    // Escuta eventos de scroll e redimensionamento
    window.addEventListener('scroll', updateSidebarPosition);
    window.addEventListener('resize', () => {
        recalculateDimensions();
        updateSidebarPosition();
    });

    // Chamada inicial para ajustar a posição
    updateSidebarPosition();
});
